/* eslint-disable react/prop-types */
import React from 'react';

import { InfoItem } from '@molecules';

const FAQItem = ({ item, handleEdit }) => {
  return <InfoItem onClick={handleEdit}>{item?.question}</InfoItem>;
};

export default FAQItem;
